export const beacon_chain_1 = 'http://beacon-chain.teku-lukso.dappnode:3500';
export const consensys_explorer =
  'https://explorer.consensus.mainnet.lukso.network';
